const initialState = {
  components: {}
};

export default function styleguide(state = initialState, action = {}) {
  switch (action.type) {
    default:
      return state;
  }
}
